import FormattedListParts from './components/FormattedListParts.vue'
import RichTranslation from './components/RichTranslation'
import plugin from './plugin.vue2'
import { intl } from './translation'
import useTranslations from './useTranslations'

export { RichTranslation, useTranslations, FormattedListParts, intl }
export default plugin
